import { useState, useEffect, useRef } from 'react';
import BlockGuard from './core.js';

export function useBlockGuard(options = {}) {
  const [state, setState] = useState({ detected: null, reason: null, checking: true });
  const guardRef = useRef(null);

  useEffect(() => {
    const bg = new BlockGuard({
      ...options,
      checkOnLoad: false,   // We control timing via useEffect
      onResult: (detected, reason) => {
        setState({ detected, reason, checking: false });
      },
    });
    guardRef.current = bg;
    bg.check();

    return () => bg.destroy();
  }, []);

  return state;
}

export { BlockGuard };
export default BlockGuard;
